import { Flex } from "@chakra-ui/react";
import { Select } from "antd";
import { SubmitHandler } from "react-hook-form";
import { GiEmptyHourglass } from "react-icons/gi";
import strings from "../../localization/main";
import { primaryWhite } from "../../theme/theme";
import CustomButton from "../buttons/CustomButton";
import FormCancelButton from "../buttons/FormCancelButton";
import FormContainer from "../forms/FormContainer/FormContainer";
import FormSelect from "../forms/FormContainer/FormSelect";

interface FormProps {
  initialValues?: any;
  onSubmit: SubmitHandler<any>;
  loading?: boolean;
  title: string;
  onClose: () => void;
}

const TakeBreakForm = ({
  initialValues,
  loading,
  onSubmit,
  title,
  onClose,
}: FormProps) => {
  const options = ["Tea", "Lunch", "Health", "Meeting", "Personal", "Other"];

  const gridColumns = {
    base: 1,
    lg: 2,
  };

  const gridSpacing = "1rem";

  return (
    <Flex w={"100%"}>
      <Flex
        gap={"1rem"}
        bg={primaryWhite}
        borderRadius={"5px"}
        w={"full"}
        h={"fit-content"}
        direction={"column"}
      >
        <FormContainer
          onSubmit={onSubmit}
          columns={1}
          initialValues={initialValues}
        >
          <FormSelect
            name={"name"}
            isRequired={true}
            placeholder={strings.select_reason}
            type={"text"}
          >
            {options?.map((option) => {
              return <Select.Option value={option}>{option}</Select.Option>;
            })}
          </FormSelect>

          <Flex justify={"flex-end"} align={"center"} mt={"1rem"}>
            <FormCancelButton onClick={onClose} />
            <CustomButton type={"submit"} isLoading={loading}>
              <GiEmptyHourglass /> {"  "}
              {strings.take_break}
            </CustomButton>
          </Flex>
        </FormContainer>
      </Flex>
    </Flex>
  );
};

export default TakeBreakForm;
